import * as React from 'react';

/** Escape a user string for safe use inside a RegExp. */
function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

interface HighlightProps {
  text: string;
  /** Raw (un-normalized) query; case-insensitive. Empty → text rendered as-is. */
  query?: string | undefined;
}

/**
 * Renders `text`, wrapping every case-insensitive occurrence of `query` in a
 * `<mark>` tinted with the accent token. Used for the recordings search to show
 * which substring matched in titles and transcript snippets. Returns the bare
 * string when there is no query so non-search renders pay nothing.
 */
export function Highlight({ text, query }: HighlightProps): React.ReactElement {
  const q = query?.trim() ?? '';
  if (!q) return <>{text}</>;

  const parts = text.split(new RegExp(`(${escapeRegExp(q)})`, 'ig'));
  const lower = q.toLowerCase();
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === lower ? (
          // biome-ignore lint/suspicious/noArrayIndexKey: split parts are positional and stable per render
          <mark key={i} className="rounded-sm bg-accent/20 text-foreground">
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </>
  );
}
